module.exports = __webpack_public_path__ + "img/info.ec9ba445.svg";